<template>
  <div class="container">
    <input type="text" value="BDDWATCH" id="input" readonly />
    <img src=" https://qn.lavamusic.com/images/BDDWATCh" alt="" />
    <div class="div" @click="copy"></div>
  </div>
</template>
<script>
import dsBridge from "dsbridge";
import { Toast } from "vant";
export default {
  setup() {
    const copy = () => {
      const userAgent = navigator.userAgent;
      if (userAgent.includes("iPhone")) {
        dsBridge.call("copyToClipboard", { text: "BDDWATCH" }, () => {
          Toast("复制成功");
        });
      } else {
        const input = document.getElementById("input");
        input.select();
        document.execCommand("copy");
          Toast("复制成功");

      }
    };
    return { copy };
  },
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
}
#input {
  position: absolute;
  top: 0;
  height: 0;
  opacity: 0;
}
.div {
  width: 19%;
  height: 1.5%;
  opacity: 0;
  position: absolute;
  top: 37%;
  left: 26%;
  background: #fff;
}
img {
  display: block;
  width: 100%;
}
</style>